import { render, staticRenderFns } from "./OTPAuthenticationAndVAToOCBDialog.vue?vue&type=template&id=9ed848f0&scoped=true"
import script from "./OTPAuthenticationAndVAToOCBDialog.vue?vue&type=script&lang=js"
export * from "./OTPAuthenticationAndVAToOCBDialog.vue?vue&type=script&lang=js"
import style0 from "./OTPAuthenticationAndVAToOCBDialog.vue?vue&type=style&index=0&id=9ed848f0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ed848f0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9ed848f0')) {
      api.createRecord('9ed848f0', component.options)
    } else {
      api.reload('9ed848f0', component.options)
    }
    module.hot.accept("./OTPAuthenticationAndVAToOCBDialog.vue?vue&type=template&id=9ed848f0&scoped=true", function () {
      api.rerender('9ed848f0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sepay/dialog/OTPAuthenticationAndVAToOCBDialog.vue"
export default component.exports